/* eslint-disable prettier/prettier */
import React from 'react';
import styles from './ActivitySection.module.css';
import ActivityItem, { ActivityItemProps } from './ActivityItem';

export interface ActivitySectionProps {
	title: string;

	items: ActivityItemProps[];

	containerBg?: string;
	titleColor?: string;

	maxHeight?: string; // optional scroll
}

const ActivitySection: React.FC<ActivitySectionProps> = ({
	title,
	items,
	containerBg = '#fff',
	titleColor = '#147a58',
	maxHeight,
}) => {
	return (
		<div className={styles.wrapper}>
			{/* TITLE */}
			<div className={styles.title} style={{ color: titleColor }}>
				{title}
			</div>

			{/* CARD CONTAINER */}
			<div
				className={styles.container}
				style={{
					background: containerBg,
					maxHeight: maxHeight,
					overflowY: maxHeight ? 'auto' : 'visible',
				}}
			>
				{items.map((item, index) => (
					<ActivityItem key={index} {...item} />
				))}
			</div>
		</div>
	);
};

export default ActivitySection;
